// src/services/toast.js
import toast from "react-hot-toast";

export const showToast = (
  type = "info", // "success" | "error" | "loading" | "info"
  message = "",
  duration = 2000
) => {
  // ensure only ONE toast is visible
  toast.dismiss();

  const bg =
    type === "success"
      ? "#19a162" // green-600
      : type === "error"
      ? "#bf352b" // red-600
      : type === "loading"
      ? "#00b2ff" // blue-600
      : "#6c757d"; // gray-700
  const icon =
    type === "success"
      ? "✔"
      : type === "error"
      ? "⨯"
      : type === "loading"
      ? "…"
      : "ℹ";

  return toast.custom(
    (t) => (
      <div
        style={{
          minWidth: 280,
          maxWidth: 420,
          color: "white",
          background: bg,
          borderRadius: 10,
          
          padding: "10px 12px 14px",
          display: "grid",
          gridTemplateColumns: "20px 1fr",
          gap: 10,
          position: "relative",
          opacity: t.visible ? 1 : 0,
          transform: `translateY(${t.visible ? 0 : -6}px)`,
          transition: "all 200ms ease",
        }}
        className="shadow-sm"
      >
        <div style={{ fontWeight: 700, lineHeight: "20px" }}>{icon}</div>
        <div style={{ lineHeight: "20px" }}>{message}</div>

        {/* Progress bar */}
        <div
          style={{
            position: "absolute",
            left: 0,
            bottom: 0,
            height: 3,
            width: "100%",
            background: "rgba(255,255,255,.25)",
            overflow: "hidden",
            borderBottomLeftRadius: 10,
            borderBottomRightRadius: 10,
          }}
        >
          <div
            style={{
              height: "100%",
              width: "100%",
              background: "white",
              transformOrigin: "left",
              animation: `shrink ${duration}ms linear forwards`,
            }}
          />
        </div>
      </div>
    ),
    { duration }
  );
};

export const dismissToasts = () => toast.dismiss();
